import React from "react";
import cn from "classnames";
import styles from "../LeftSideMain.module.scss";
import LeftSideWrapper from "./LeftSideWrapper";
import LogoIcon from "../../../shared/icons/LogoIcon";
import LeftSideButtonClose from "./LeftSideButtonClose";

const LeftSideHeader = ({isExpand, toggleExpand}) => {

    return(
        <div className={cn(styles.wrapper_header, { [styles.is_mobile]: isExpand })}>
            <LogoIcon/>
            <LeftSideButtonClose isExpand={isExpand} toggleExpand={toggleExpand}/>
        </div>
    )
}

export default LeftSideHeader;